import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const ListHeader = () => {
  return (
    <Grid
      size={{ xs: 12 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        mt: 2.5,
      }}
    >
      <Typography
        variant="h5"
        sx={{ color: '#1e293b' }}
      >
        <strong>My Proposals</strong>
      </Typography>

      <Typography
        color="text.secondary"
      >
        Browse and search all generated proposals.
      </Typography>
    </Grid>
  );
};

export default ListHeader;